import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { paths } from 'utilities/routes';
import { generateSlug } from 'utilities/helpers/generateSlug';
import { locationShape } from 'utilities/data/proptypesShapes';
import './view.scss';

export const TagsView = ({
    tags, currentTag, location, currentType
}) => {
    const generateHref = (tag) => {
        const tagSlug = generateSlug(tag);
        if (currentType === 'wszystkie') {
            if (location.search === '?search=' || !location.search) {
                if (tagSlug === currentTag) return `${paths.wszystkoODrzwiach}`;
                return `${paths.wszystkoODrzwiach}/${tagSlug}`;
            }
            if (tagSlug === currentTag) return `${paths.wszystkoODrzwiach}${location.search}`;
            return `${paths.wszystkoODrzwiach}/${tagSlug}${location.search}`;
        }
        if (location.search === '?search=' || !location.search) {
            if (tagSlug === currentTag) return `${paths.artykuly}/${generateSlug(currentType)}`;
            return `${paths.artykuly}/${generateSlug(currentType)}/${tagSlug}`;
        }
        if (tagSlug === currentTag) return `${paths.artykuly}/${generateSlug(currentType)}${location.search}`;
        return `${paths.artykuly}/${generateSlug(currentType)}/${tagSlug}${location.search}`;
    };

    return (
        <section className="tags">
            <div className="tags__categories">
                {
                    tags.sort().map((tag) => (
                        <Link
                            className={
                                classnames('tags__tag', {
                                    tags__tag__active: currentTag === generateSlug(tag)
                                })
                            }
                            to={ generateHref(tag) }
                        >
                            {tag}
                        </Link>
                    ))
                }
            </div>
        </section>
    );
};

TagsView.propTypes = {
    tags: PropTypes.instanceOf(Array).isRequired,
    currentType: PropTypes.string.isRequired,
    currentTag: PropTypes.string.isRequired,
    location: PropTypes.shape(locationShape).isRequired
};